// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "" + chunkId + "." + {"15125":"84a84e1fb62bc89ce8c6","25825":"fba2aa01ed1640ec2555","80020":"c35e2e1f3a3bf913dd16"}[chunkId] + ".css";
};